import { Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <Container
      className="d-flex flex-column justify-content-center align-items-center text-center"
      style={{ minHeight: "70vh", maxWidth: "32rem" }}
    >
      <span className="sb-eyebrow">Page not found</span>
      <h1 className="display-5 fw-bold">Nothing here.</h1>
      <p className="text-muted mt-2">
        The page you were looking for has moved or never existed.
      </p>
      <div className="d-flex gap-2 mt-3">
        <Link to="/" className="text-decoration-none">
          <Button variant="primary" className="btn-rounded px-4">
            Home
          </Button>
        </Link>
        <Link to="/shop" className="text-decoration-none">
          <Button variant="outline-secondary" className="btn-rounded px-4">
            Shop
          </Button>
        </Link>
      </div>
    </Container>
  );
}

export default NotFound;
